document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.mobile-mega-menu').forEach(menu => {

    const menuId = menu.dataset.megaMenu; 

    const toggles = menu.querySelectorAll('.accordion-toggle');

    toggles.forEach(toggle => {
      toggle.addEventListener('click', function () {

        const section = toggle.closest('.mobile-mega-menu__section');
        if (!section) return;

        const content = section.querySelector('.accordion-content');
        if (!content) return;

        content.classList.toggle('is-closed');
        toggle.classList.toggle('active');

        
        

      });
    });

  });

});
